import { css, token } from '@terra/ui-styled-system';

export const terminalPromptColor = token('colors.green.dark.11');
export const terminalStderrColor = token('colors.red.dark.11');

export const terminalCodeBlockStyles = css({
  bg: token('colors.gray.dark.3'),
  borderRadius: 'sm',
  px: 3,
  py: 2,
  fontFamily: 'mono',
  fontSize: 'xs',
  lineHeight: '1.5',
  color: token('colors.gray.dark.11'),
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});

export const terminalTextareaStyles = css({
  bg: 'transparent',
  border: 'none',
  outline: 'none',
  color: token('colors.gray.dark.11'),
  fontFamily: 'mono',
  fontSize: 'xs',
  lineHeight: '1.5',
  width: '100%',
  resize: 'none',
  overflow: 'hidden',
  minH: '1.5em',
  p: 0,
  _focus: { outline: 'none', boxShadow: 'none' },
});
